import Vue from 'vue';
import errorMixin from './error';
import routerMixin from './router';
import trackerMixin from './tracker';

Vue.mixin(errorMixin);
Vue.mixin(routerMixin);
Vue.mixin(trackerMixin);



// WEBPACK FOOTER //
// ./src/app/mixins/global/_register.js